import Layout from 'antd/lib/layout'

import 'antd/lib/layout/style'

export * from 'antd/lib/layout'

export default Layout
